import { render, staticRenderFns } from "./InsNotice.vue?vue&type=template&id=5305692f&scoped=true"
import script from "./InsNotice.vue?vue&type=script&lang=js"
export * from "./InsNotice.vue?vue&type=script&lang=js"
import style0 from "./InsNotice.vue?vue&type=style&index=0&id=5305692f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5305692f",
  null
  
)

export default component.exports